import { render } from "./TrxMgrView.vue?vue&type=template&id=41af36c1"
import script from "./TrxMgrView.vue?vue&type=script&lang=js"
export * from "./TrxMgrView.vue?vue&type=script&lang=js"

import "./TrxMgrView.vue?vue&type=style&index=0&id=41af36c1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__